var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "form",
    {
      ref: _vm.refFormTerminalData,
      on: {
        submit: function ($event) {
          $event.preventDefault()
          return _vm.submitEmitter.apply(null, arguments)
        },
      },
    },
    [
      _c("div", { staticClass: "emd-panel" }, [
        _c("div", { staticClass: "emd-panel__section" }, [
          _c("div", { staticClass: "emd-panel__block" }, [
            _c("div", { staticClass: "el-chunk" }, [
              _c(
                "h2",
                { staticClass: "emd-text _color_default _type_caption" },
                [_vm._v(" " + _vm._s(_vm.$t("title")) + " ")]
              ),
            ]),
          ]),
          _c("div", { staticClass: "emd-panel__block" }, [
            _c(
              "div",
              { staticClass: "el-chunk" },
              _vm._l(_vm.fields, function (item) {
                return _c("div", { key: item, staticClass: "emd-form-group" }, [
                  _c(
                    "label",
                    { staticClass: "emd-label", attrs: { for: item } },
                    [_vm._v(_vm._s(_vm.$t(item)))]
                  ),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form[item],
                        expression: "form[item]",
                      },
                    ],
                    staticClass: "emd-input",
                    attrs: {
                      "data-testid": item,
                      disabled: _vm.disabled,
                      id: item,
                    },
                    domProps: { value: _vm.form[item] },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(_vm.form, item, $event.target.value)
                      },
                    },
                  }),
                ])
              }),
              0
            ),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }